<app-background-animation></app-background-animation>
<div class="accept-invite-container">
    <div class="invite-card">
        <mat-card>
            <mat-card-header>
                <div class="rotating-logo"></div>
            </mat-card-header>
            <mat-card-content>
                <div>
                    <h2>{{ setup ? 'Choose your password' : 'Reset Password' }}</h2>
                    <p *ngIf="setup">Your MedicAI account is ready. Choose a password to sign in.</p>
                    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
                        <mat-form-field appearance="outline" class="m-r-10">
                            <mat-label>New Password</mat-label>
                            <input matInput type="password" formControlName="password" required
                                name="new-password" autocomplete="new-password">
                            <mat-progress-bar *ngIf="resetPasswordForm.get('password')?.value" mode="determinate"
                                [value]="passwordStrength"
                                [class.weak]="resetPasswordForm.get('password')?.errors?.['passwordStrength']">
                            </mat-progress-bar>
                            <mat-error
                                *ngIf="resetPasswordForm.get('password')?.touched && resetPasswordForm.get('password')?.errors?.['passwordStrength']">
                                {{ resetPasswordForm.get('password')?.errors?.['passwordStrength'] }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Confirm Password</mat-label>
                            <input matInput type="password" formControlName="confirmPassword" required
                                name="confirm-new-password" autocomplete="new-password">
                            <mat-error *ngIf="resetPasswordForm.get('confirmPassword')?.invalid">Please confirm your
                                password</mat-error>
                        </mat-form-field>
                        <button mat-raised-button color="primary" type="submit">{{ setup ? 'Set password' : 'Reset Password' }}</button>
                    </form>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>